import React, { useState, useEffect } from "react";
import Table from "../../../../Components/UiComponents/Table/Table";
import { useNavigate } from "react-router-dom";
import {
  Editicon,
  Deleteicon,
  PaperClipIcon,
  Pencil,
  Trash,
  Viewicon,
  EditConvgIcon,
  DeleteConvgIcon,
} from "../../../../Components/IconComponents";
import { useDispatch } from "react-redux";
import { viewtaskcolumnsForExportView } from "../../../../JsonData/CreateTaskConfig";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import {
  downloadFile,
  getExportedColumnsData,
} from "../../../../Components/UiComponents/utils";
import { getActiveTasksURL, getDeletedTasksURL, deleteTaskURL, getActiveMasterSOPList, getThemeURL } from "../../../../Services/EndPoints";
import { getData, putDataWithBody } from "../../../../Services/Services";
import Moment from "react-moment";
import { toast } from "react-toastify";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import Loader from "react-spinner-loader";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import PreviewFile from "../../Common/Form/PreviewFile/PreviewFile";
import AttachmentGallery from "../../Common/Form/AttachmentGallery/AttachmentGallery";
import { getCategoryBadgeStyle } from "../../Common/badgeStyles";

const getFileNameFromUrl = (url = "") => {
  try {
    const decoded = decodeURIComponent(url.split("?")[0]);
    return decoded.substring(decoded.lastIndexOf("/") + 1) || "Attachment";
  } catch (e) {
    return "Attachment";
  }
};

// The list API returns multiple attachments as a single comma-separated
// string on task_file_name.
const parseAttachmentList = (value) => {
  if (!value) return [];
  return String(value)
    .split(",")
    .map((url) => url.trim())
    .filter(Boolean);
};

const ViewTask = () => {
  const [data, setData] = useState([]);
  const [inactiveData, setInactiveData] = useState([]);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [viewTypeData, setViewTypeData] = useState([]);
  const [incidentTypeData, setIncidentTypeData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [inactiveRowCount, setInactiveRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [checkData, setCheckData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [attachmentUrls, setAttachmentUrls] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleImageClick = (value) => {
    const urls = parseAttachmentList(value);
    if (urls.length === 1) {
      setPreviewUrl(urls[0]);
    } else {
      setAttachmentUrls(urls);
      setShowModal(true);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };
  useEffect(() => {
    getTaskLists();
    getSOPMasterList();
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 25) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };
  async function getTaskLists() {
    setLoader(true);
    try {
      const userProfile = await getData(getThemeURL);
      const state_id = userProfile[0]?.state_id;
      const [activeList, deletedList] = await Promise.all([
        getData(getActiveTasksURL.replace("STATEID", state_id)),
        getData(getDeletedTasksURL.replace("STATEID", state_id)),
      ]);

      const sortByCreatedOn = (list) =>
        (Array.isArray(list) ? list : []).sort((a, b) => new Date(b.created_on) - new Date(a.created_on));

      const sortedActive = sortByCreatedOn(activeList).map((item) => ({ ...item, isDeleted: false }));
      const sortedDeleted = sortByCreatedOn(deletedList).map((item) => ({ ...item, isDeleted: true }));

      setData(sortedActive);
      setInactiveData(sortedDeleted);
      setRowCount(sortedActive.length);
      setInactiveRowCount(sortedDeleted.length);
    } catch (error) {
      console.error("Error fetching task lists:", error);
    } finally {
      setLoader(false);
    }
  }

  const getSOPMasterList = async () => {
    setLoader(true);
    const userProfile = await getData(getThemeURL);
              const state_id = userProfile[0]?.state_id;
    var sopMasterList = await getData(`${getActiveMasterSOPList}/${state_id}`);
    let sortedList = sopMasterList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    setLoader(false);
    setCheckData(sortedList);
  };
 
  // Function to check if a task name exists in checkData's task_list property
  const isTaskInMasterSOP = (taskName) => {
    if (!taskName || !checkData || checkData.length === 0) return false;
   
    // Check if the task name exists in any of the checkData task_list strings
    return checkData.some(item => {
      if (!item.task_list) return false;
      // Split the task_list string by commas and check if taskName is included
      const taskList = item.task_list.split(',').map(task => task.trim());
      return taskList.includes(taskName);
    });
  };

  function addNewHandler() {
    navigate("/planning/create-task");
  }

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = viewtaskcolumnsForExportView;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Task ID",
        accessor: "task_seq_id",
        disableSortBy: true,
      },
      {
        Header: t("taskmanagementtableheaders.sopname"),
        accessor: "task_name",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return getShortenedText(15, props.value);
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("taskmanagementtableheaders.incidenttype"),
        accessor: "incident_type",

        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <span style={getCategoryBadgeStyle(props.value)}>{props.value}</span>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("taskmanagementtableheaders.tasktype"),
        accessor: "task_type",
        disableSortBy: true,
      },
      {
        Header: t("taskmanagementtableheaders.assignedto"),
        accessor: "role_name",

        Cell: (props) => {
          if (props.value) {
            return getShortenedText(25, props.value);
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("taskmanagementtableheaders.Createdon"),
        accessor: "created_on",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: false,
      },
      // {
      //   Header: "Attachment",
      //   accessor: "media_file_path",
      //   disableSortBy: true,
      //   Cell: (props) => {
      //     if (props.value && props.value != null) {
      //       let downloadAttachmentURL =
      //         process.env.REACT_APP_APP_SERVER_ADDRESS +
      //         "/" +
      //         process.env.REACT_APP_CORE_CONTEXT_PATH_NAME +
      //         "/download/download_attachments/?directoryPath=" +
      //         props.value +
      //         "&fileName=Tasks.zip";
      //       return (
      //         <div className="text-center">
      //           <span className="icon__position">
      //             <div
      //               onClick={() =>
      //                 downloadFile(
      //                   downloadAttachmentURL,
      //                   "Tasks" + new Date().getTime() + ".zip"
      //                 )
      //               }
      //             >
      //               <PaperClipIcon className="cursor-pointer" />
      //             </div>
      //           </span>
      //         </div>
      //       );
      //     } else {
      //       return "";
      //     }
      //   },
      // },
      {
        Header: () => <div style={{ textAlign: "center" }}>{t("soprelatedtasktableheaders.Viewimage")}</div>,
        accessor: "task_file_name",
        disableSortBy: true,
        Cell: ({ value }) => (
          <div style={{ textAlign: "center" }}>
            {value ? (
              <Viewicon
                onClick={() => handleImageClick(value)}
                style={{ cursor: "pointer", color: "#007bff", width: "18px", height: "18px" }}
                title="View attachment"
              />
            ) : (
              <Viewicon
                style={{ cursor: "default", color: "#ced4da", width: "18px", height: "18px" }}
                title="No attachment"
              />
            )}
          </div>
        ),
      },
      {
        Header: t("taskmanagementtableheaders.action"),
        disableSortBy: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteTaskURL, data, {});
            if (res.status == "success") {
              getTaskLists();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };
 
          // Check if the task name is in any of the checkData task_list
          const taskName = props.row.original.task_name;
          const isDisabled = isTaskInMasterSOP(taskName);
          // Inactive (deleted) tasks are shown in their own table with view only.
          const rowDeleted = props.row.original.isDeleted === true;

          return (
            <div className="usertable__actionsicon">
              <span
                title="View"
                onClick={() =>
                  navigate("/planning/view-taskinfo", {
                    state: { data: props.row.original },
                  })
                }
              >
                <Viewicon value={props.value} className="cursor-pointer me-2" />
              </span>

              {!rowDeleted && (
                <span
                  title={isDisabled ? "This task is linked to a Master SOP and can't be edited here" : "Edit"}
                  style={isDisabled ? { cursor: 'not-allowed' } : undefined}
                  onClick={() => {
                    if (!isDisabled) {
                        navigate("/planning/create-task", {
                        state: {
                          data: props.row.original,
                          edit: true
                        },
                      });
                    }
                  }}
                >
                  <Editicon
                    value={props.value}
                    className={`me-2 ${isDisabled ? 'text-muted' : 'cursor-pointer'}`}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  />
                </span>
              )}

              {!rowDeleted && (
                <span
                  title={isDisabled ? "This task is linked to a Master SOP and can't be deleted here" : "Delete"}
                  onClick={!isDisabled ? deletePopUp : null}
                >
                  <Deleteicon
                    value={props.value}
                    className={`mr-1 ${isDisabled ? 'text-muted' : 'cursor-pointer'}`}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  />
                </span>
              )}
              {isdelete && !isDisabled && !rowDeleted && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.title}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, checkData]
  );

  return (
    <div>
      <div className="create-user">
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />
        <style>{`
          .view-task-table tbody tr td,
          .view-task-table tbody tr th {
            border: none !important;
          }
          .view-task-table tbody tr td {
            background-color: #fff !important;
            color: #1D2939 !important;
          }
          .view-task-table tbody tr:nth-child(even) td {
            background-color: #F9FAFB !important;
          }
        `}</style>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            gap: "8px",
            padding: "10px 16px",
            borderLeft: "4px solid #2E6DA4",
            background: "#f4f8fb",
            borderBottom: "1px solid #e5e9ef",
          }}
        >
          <span style={{ fontSize: "12px", fontWeight: 700, color: "#1a2e35", letterSpacing: ".2px" }}>
            Active Tasks
          </span>
          <span style={{ fontSize: "10.5px", color: "#5b6b7a" }}>
            Live tasks — create, edit, view and delete
          </span>
        </div>
        <div className="datatable__container view-task-table">
          <Table
            data={data}
            title=""
            addButtonLabel={t("taskaddButtonLabel")}
            addNewHandler={addNewHandler}
            showFilter={false}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            showExport={false}
            showReset={false}
            onExpand={false}
            showSearch={true}
            isHeaderFixed={true}
            rowCount={rowCount} // Pass rowCount to the Table component
            // addButtonLabel="Add New"
            // addNewHandler={addNewHandler}
            headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #f0f0f0",
              borderBottom: inactiveData.length > 0 ? "none" : "1px solid #f0f0f0",
              padding: "2px",
              borderRadius: inactiveData.length > 0 ? "12px 12px 0 0" : "12px",
            }}
          />
        </div>

        {inactiveData.length > 0 && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "8px",
                padding: "10px 16px",
                marginTop: "18px",
                borderLeft: "4px solid #94a3b8",
                borderTop: "1px solid #e5e9ef",
                borderBottom: "1px solid #e5e9ef",
                background: "#f4f5f7",
              }}
            >
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#5b6b7a", letterSpacing: ".2px" }}>
                Inactive Tasks
              </span>
              <span style={{ fontSize: "10.5px", color: "#8a97a3" }}>
                Deleted tasks — view only
              </span>
            </div>
            <div className="datatable__container view-task-table" style={{ paddingBottom: "12px" }}>
              <Table
                data={inactiveData}
                title=""
                showFilter={false}
                columns={columns}
                numberOfRows={10}
                showExport={false}
                showReset={false}
                onExpand={false}
                showSearch={false}
                isHeaderFixed={true}
                rowCount={inactiveRowCount}
                headerTableHeadStyle={{ background: "linear-gradient(120deg, #64748b 0%, #94a3b8 100%)", color: "#FFFFFF" }}
                tableStyle={{
                  border: "1px solid #f0f0f0",
                  borderTop: "none",
                  padding: "2px",
                  borderRadius: "0 0 12px 12px",
                }}
              />
            </div>
          </>
        )}
      </div>
       <Modal show={showModal} onHide={handleClose} centered enforceFocus={false}>
         <Modal.Header closeButton>
           <Modal.Title>Attachments ({attachmentUrls.length})</Modal.Title>
         </Modal.Header>
         <Modal.Body>
           <AttachmentGallery
             urls={attachmentUrls}
             onOpen={setPreviewUrl}
           />
         </Modal.Body>
       </Modal>
       {previewUrl && (
         <PreviewFile
           file={{ name: getFileNameFromUrl(previewUrl), url: previewUrl }}
           show={!!previewUrl}
           previewHandler={() => setPreviewUrl(null)}
           title="Attachment Preview"
         />
       )}
    </div>
  );
};

export default ViewTask;
